import Vue from "vue";
import auth from "@websanova/vue-auth/src/v2.js";
import driverHttpAxios from "@websanova/vue-auth/src/drivers/http/axios.1.x.js";
import driverRouterVueRouter from "@websanova/vue-auth/src/drivers/router/vue-router.2.x.js";
import driverJwt from "./drivers/jwt";

Vue.use(auth, {
  plugins: {
    http: Vue.axios,
    router: Vue.router
  },
  drivers: {
    auth: driverJwt,
    http: driverHttpAxios,
    router: driverRouterVueRouter
  },
  options: {
    rolesKey: "roles",
    loginData: { url: "jwt/login" },
    refreshData: {
      url: "jwt/refresh",
      error: function(response) {
        if (response.status === 401 || response.status === 403) {
          console.warn("🔄 Token refresh failed with status:", response.status);
          console.warn("Reloading the page...");
          window.location.reload();
        }
        return response;
      }
    },
    logoutData: { url: "jwt/logout", redirect: "/login" },
    fetchData: {
      url: "users/me",
      error: function(response) {
        if (response.status === 403) {
          const errorMsg = response.data?.error || "Access denied";
          localStorage.setItem("usersFetchErrorMessage", errorMsg);
          console.log("Stored error message in localStorage:", errorMsg);
        }
        if (response.status === 401) {
          window.location.reload();
        }
        return response;
      }
    },
    refreshTokenName: "auth_token_refresh",
    forbiddenRedirect: function() {
      if (Vue.auth.check("new") || Vue.auth.check("denied")) {
        return "/denied";
      }
      return "/";
    }
  }
});

Vue.axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response) {
      const { status, config } = error.response;

      if (
        config.url.includes("jwt/refresh") &&
        (status === 401 || status === 403)
      ) {
        console.warn("🔁 Global interceptor: Refresh token failed", status);
        console.warn("Reloading the page...");
        setTimeout(() => window.location.reload(), 1000);
      }

      if (status === 403 && config.url.includes("users/me")) {
        const errorMsg = error.response.data?.error || "Access denied";
        localStorage.setItem("usersFetchErrorMessage", errorMsg);
        console.log(
          "Interceptor stored error message in localStorage:",
          errorMsg
        );
      }

      if (status === 401 && config.url.includes("users/me")) {
        window.location.reload();
      }
    }

    return Promise.reject(error);
  }
);

export default {};
